import React from 'react';
import { UUID } from '@/types';
import { useNavigateToNextQuery } from './useNavigateToNextQuery';
import { useReplaceLocalStepsWithFetchedSteps } from './useReplaceLocalStepsWithFetchedSteps';
import { useSaveQuerySteps } from './useSaveQuerySteps';
import { useSetLastUpdateMethodToLoaded } from './useSetLastUpdateMethodToLoaded';
import { useUpdateLastVisitedQueryURL } from './useUpdateLastVisitedQueryURL';
import { useResetRowsLoading } from './useResetRowsLoading';

export const useQueryBuilderStepsFlow = () => {
  const currentQueryIdRef = React.useRef<UUID>();

  useUpdateLastVisitedQueryURL();
  useSetLastUpdateMethodToLoaded(currentQueryIdRef);
  useReplaceLocalStepsWithFetchedSteps();
  useResetRowsLoading();

  const nextQueryId = useSaveQuerySteps();
  useNavigateToNextQuery(nextQueryId, currentQueryIdRef);
};
